import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';


function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="determinate" {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};


const Courses = (props) => {
    return (
        <Link to={`/education/mycourses/${props.data.id}`} className="MyCourses">
            <div className="infos">
                <span className="name">{props.data.title}</span>
                <span className="date">{props.data.string_date}</span>
                <span className="grade">نمره قبولی : <b>{props.data.pass_score}</b></span>
                <span className="mark">امتیاز من از این کورس : <b>{props.data.score}<i className="icon-black-star-silhouette"></i></b></span>
            </div>
            <div className="progress">
                <CircularProgressWithLabel value={props.data.pass_percent} />
                <span>درصد پیشرفت</span>
                <div className="progress-bar"></div>
            </div>
        </Link>
    );
}

export default Courses;